import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Label } from "../Label/Label";
import { InputMessageGroup } from "../InputMessageGroup/InputMessageGroup";
export const TextArea = React.forwardRef(({ onChange, value, maxChars, showCount, hideLabel, errorMessage, message, hasErrors, noBorder = false, id, resize = "none", label, subtitle, autoResize, maxRows, minRows = 1, defaultValue, className, style, ...rest }, ref) => {
    const localRef = React.useRef(null);
    const [localInputValue, setLocalInputValue] = React.useState(defaultValue || value);
    React.useEffect(() => setLocalInputValue(value), [value]);
    const handleChange = (e) => {
        setLocalInputValue(e.target.value);
        if (onChange) {
            onChange(e);
        }
    };
    const valueSpreadMapping = value === undefined ? { defaultValue } : { value: localInputValue };
    // Based of vertical padding and font size vs line height
    const maxHeight = maxRows ? `calc(32px + ${maxRows * 1.5}rem)` : "none";
    return (_jsxs("div", { children: [_jsx(Label, { htmlFor: id, font: "title-6", screenReaderOnly: hideLabel, hasErrors: hasErrors, children: label }), subtitle && (_jsx(Label, { htmlFor: id, font: "body-3", color: "text-secondary", children: subtitle })), _jsx("div", { className: classNames("eds-text-field", {
                    "eds-text-field--no-border": noBorder,
                    "eds-text-field--auto-resize": autoResize,
                }, className), "data-auto-resize": autoResize ? localInputValue : undefined, style: { maxHeight }, children: _jsx("textarea", { className: classNames("eds-text-field__input", {
                        "eds-text-field__input--error": hasErrors,
                        "eds-text-field__input--no-border": noBorder === true,
                    }), rows: minRows, id: id, style: { maxHeight, resize, ...style }, ref: node => {
                        if (localRef !== null) {
                            localRef.current = node;
                        }
                        if (ref !== null) {
                            // eslint-disable-next-line no-param-reassign
                            ref.current = node;
                        }
                    }, onChange: handleChange, "aria-describedby": `${id}-meta`, ...valueSpreadMapping, ...rest }) }), (hasErrors || maxChars || showCount || message) && (_jsx(InputMessageGroup, { id: `${id}-meta`, message: message, errorMessage: hasErrors && (errorMessage || "Error"), count: showCount ? localInputValue === null || localInputValue === void 0 ? void 0 : localInputValue.toString().length : undefined, maxCount: showCount ? maxChars : undefined }))] }));
});
